module.exports = __webpack_public_path__ + "img/no-data-found.9d0d4eff.png";